import { i18nDateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { usePrivateIntegrationsSyncContext } from 'modules/integrations/hooks/SyncContext'
import { useSyncRunSyncing } from 'modules/integrations/hooks/useSyncRunSyncing'

export type SyncMetadataItem = {
  label: string
  value: {
    type: 'text'
    content: string
  }
}

const formatDate = (date: string): string => {
  return i18nDateToString(stringToDate(date, 'backend_datetime'), 'ui_month_day_time')
}

const metadataBuilder = (title: string, value: string): SyncMetadataItem => {
  return {
    label: title,
    value: {
      type: 'text',
      content: value,
    },
  }
}

export const useSyncMetadata = (): SyncMetadataItem => {
  const { isSyncing, lastSyncRun, capabilityMode } = usePrivateIntegrationsSyncContext()
  const { isLoading, syncingLabel, syncingCounter } = useSyncRunSyncing({ skip: !isSyncing })
  const isExportMode = capabilityMode === 'file'

  if (isSyncing && isLoading) return metadataBuilder(syncingLabel, '')
  else if (isSyncing) return metadataBuilder(`${syncingLabel} ${syncingCounter}`, '')
  else if (lastSyncRun?.finishedAt)
    return metadataBuilder(
      isExportMode
        ? i18n.t('integrations.footer.last_export')
        : i18n.t('integrations.footer.last_sync'),
      formatDate(lastSyncRun.finishedAt)
    )
  return metadataBuilder(
    isExportMode
      ? i18n.t('integrations.footer.no_last_export')
      : i18n.t('integrations.footer.no_last_sync'),
    ''
  )
}
